<template>
  <SwitchGroup as="div" class="flex items-center">
    <Switch
      :model-value="modelValue"
      :small="small"
      :disabled="disabled"
      :loading="loading"
      :tooltip="tooltip"
      :tooltip-placement="tooltipPlacement"
      @update:modelValue="!disabled && $emit('update:modelValue', $event)"
    >
      <template #icon>
        <slot name="icon" />
      </template>
    </Switch>
    <SwitchLabel as="span" class="ml-3">
      <slot></slot>
    </SwitchLabel>
  </SwitchGroup>
</template>

<script lang="ts" setup>
//Components
import Switch from "@atoms/SwitchButton.vue";
import { SwitchGroup, SwitchLabel } from "@headlessui/vue";

//Types
import type { Placement } from "@popperjs/core";

//Props
withDefaults(
  defineProps<{
    small?: boolean;
    disabled?: boolean;
    modelValue?: boolean;
    loading?: boolean;
    tooltip?: string;
    tooltipPlacement?: Placement;
  }>(),
  {
    small: false,
    disabled: false,
    modelValue: false,
    loading: false,
    tooltip: "",
    tooltipPlacement: "auto",
  }
);

//Emits
defineEmits<{
  (e: "update:modelValue", modelValue: boolean): void;
}>();
</script>
